document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('slider-component').forEach(sliderComponent => {
    const slider = sliderComponent.querySelector('.slider');
    const currentCounter = sliderComponent.querySelector('.slider-counter--current');
    const totalCounter = sliderComponent.querySelector('.slider-counter--total');
    const dots = sliderComponent.querySelectorAll('.slider-pagination__dot');
    
    if (!slider || !currentCounter || !totalCounter || !dots.length) return;
    function updateDotsFromCounters() {
      const currentIndex = parseInt(currentCounter.textContent) - 1; 
      const totalPages = parseInt(totalCounter.textContent);
      dots.forEach((dot, index) => {
        if (index < totalPages) {
          dot.style.display = 'inline-block';
          dot.classList.toggle('slider-pagination__dot--active', index === currentIndex);
        } else {
          dot.style.display = 'none';
        }
      });
    }
    dots.forEach((dot, index) => {
      dot.addEventListener('click', (e) => {
        e.preventDefault();
        const slides = slider.querySelectorAll('.slider__slide');
        const targetSlide = slides[index];
        
        if (targetSlide) {

          targetSlide.scrollIntoView({
            behavior: 'smooth',
            block: 'nearest',
            inline: 'start'
          });

          currentCounter.textContent = index + 1;

          setTimeout(() => {
            updateDotsFromCounters();
          }, 100);
        }
      });
    });
    
    // Watch for changes in the counter elements
    const observer = new MutationObserver(() => {
      updateDotsFromCounters();
    });
    
    // Observe changes to counter text content
    observer.observe(currentCounter, { childList: true, subtree: true, characterData: true });
    observer.observe(totalCounter, { childList: true, subtree: true, characterData: true });
    
    // Initial update
    updateDotsFromCounters();
  });
}); 
document.addEventListener("DOMContentLoaded", function() {
  var descElements = document.getElementsByClassName("u-u-u-accordion-item-desc");
  for (var j = 0; j < descElements.length; j++) {
    descElements[j].style.maxHeight = descElements[j].scrollHeight + "px";
  }
  var coll = document.getElementsByClassName("u-accordion-item-title");
  for (var i = 0; i < coll.length; i++) {
    coll[i].addEventListener("click", function() {
      this.classList.toggle("active");
      var content = this.nextElementSibling;
      var desc = content.querySelector(".u-u-u-accordion-item-desc");
      if (content.style.maxHeight) {
        content.style.maxHeight = null; 
      } else {
        content.style.maxHeight = content.scrollHeight + "px"; 
      }
    });
  }
});
function reviewsinitializeSwiper() {
  var swiper = new Swiper(".u-mySwiper", {
    spaceBetween: 30,
    navigation: {
        nextEl: ".m-category-next",
        prevEl: ".m-category-prev",
      },    
    breakpoints: {
      348: {
        centeredSlides: true,
        slidesPerView: 1.2,
        spaceBetween: 10,
        centeredSlidesBounds: true,
      },
      640: {
        slidesPerView: 2.2,
        spaceBetween: 10,
      },
      1024: {
        slidesPerView: 3.3,
        spaceBetween: 10,
      }
    }
  });
}
function instalinkSwiper() {
  var swiper = new Swiper(".mISSwiper", {
    spaceBetween: 10,
    navigation: {
        nextEl: ".m-insta-next",
        prevEl: ".m-insta-prev",
      },  
    breakpoints: {
      348: {
        slidesPerView: 2.2,
        spaceBetween: 8,
      },
      640: {
        slidesPerView: 2.2,
        spaceBetween: 8,
      },
      769: {
        slidesPerView: 3.2,
        spaceBetween: 8,
      },
      869: {
        slidesPerView: 4.2,
        spaceBetween: 8,
      },
      1024: {
        slidesPerView: 5.2,
        spaceBetween: 8,
      }
    }
  });
}
function AnnouncementSlider() {
    var swiper = new Swiper(".cstm-announcement", {
      spaceBetween: 20,
      autoplay: true,
      breakpoints: {
        0: {
          slidesPerView: 1,
        },
        640: {
          slidesPerView: 2,
        },
        768: {
          slidesPerView: 3,
        }
      }
    });
  }
document.addEventListener('DOMContentLoaded', () => {
  const headings = document.querySelectorAll('.m-footer-block-heading');
  const mq        = window.matchMedia('(max-width: 748px)');

  // Set up (or tear down) accordion behaviour depending on viewport size
  function applyAccordion(enable) {
    headings.forEach(heading => {
      const list = heading.parentElement.querySelector('.m-dd-list');

      if (!list) return;

      /* --- enable accordion for mobile --- */
      if (enable) {
        // Collapse by default
        list.style.maxHeight = list.style.maxHeight || '0';
        heading.classList.remove('is-open');

        // Avoid stacking multiple identical listeners
        if (!heading._accordionBound) {
          heading.addEventListener('click', onClick);
          heading._accordionBound = true;
        }
      }
      /* --- disable accordion for desktop --- */
      else {
        list.style.maxHeight = '';  // let CSS handle height
        heading.classList.remove('is-open');

        if (heading._accordionBound) {
          heading.removeEventListener('click', onClick);
          heading._accordionBound = false;
        }
      }
    });
  }

  // Toggle handler (runs only when accordion is enabled)
  function onClick(evt) {
    const heading = evt.currentTarget;
    const list    = heading.parentElement.querySelector('.m-dd-list');
    const isOpen  = list.style.maxHeight && list.style.maxHeight !== '0px';

    /* Optional accordion: close neighbours */
    headings.forEach(other => {
      if (other !== heading) {
        const otherList = other.parentElement.querySelector('.m-dd-list');
        if (otherList) {
          otherList.style.maxHeight = '0';
          other.classList.remove('is-open');
        }
      }
    });

    if (isOpen) {
      list.style.maxHeight = '0';
      heading.classList.remove('is-open');
    } else {
      list.style.maxHeight = list.scrollHeight + 'px';
      heading.classList.add('is-open');
    }
  }
  applyAccordion(mq.matches);
  mq.addEventListener('change', e => applyAccordion(e.matches));
});

// Sticky ATC
function isElementMovedUpAndOutOfViewport(el) {
    var rect = el.getBoundingClientRect();
    return (
        rect.bottom <= 0 &&
        rect.top < window.innerHeight
    );
}

function checkVisibility() {
    let ogPaymentElement = document.querySelector(".og-payment");
    let stickyatc = document.querySelector("#cstm-sticky-bar");
    if (isElementMovedUpAndOutOfViewport(ogPaymentElement)) {
        stickyatc.classList.add("mvisible");
    } else {
        stickyatc.classList.remove("mvisible");
    }
}  
  window.addEventListener("scroll", checkVisibility);
  window.addEventListener("resize", checkVisibility); // Listen for window resize
  checkVisibility();